@for (gr of plots(); track gr; let ind = $index) {
  <div class="card" style="margin-top: 10px; margin-bottom: 10px; padding: 10px">
    <div class="card-header" style="padding: 0">
      <div class="clr-row nxm">
        <div class="clr-col-6">
          <div class="clr-row" style="margin-left: 10px">
            <div class="clr-col">
              <cds-icon
                shape="angle"
                size="25"
                (click)="gr.show = !gr.show"
                [direction]="gr.show ? 'up' : 'down'"
                style="cursor: pointer; margin-left: -15px; margin-right: 8px"></cds-icon>
              {{ gr.title | mrTranslate }}
            </div>
          </div>
        </div>
        <div class="clr-col-6" style="text-align: right">
          <!-- <button class="btn btn-icon" (click)="loadDetailView(gr)" style="margin-top: -5px">
          <cds-icon shape="search" />
        </button> -->
          <clr-signpost>
            <cds-icon shape="cog" solid="true" clrSignpostTrigger style="margin-top: -10px"></cds-icon>
            <clr-signpost-content [clrPosition]="'left-bottom'" *clrIfOpen>
              <form clrForm>
                <clr-input-container style="margin-top: 10px">
                  <label>{{ 'Y-Max' | mrTranslate }}</label>
                  <input clrInput placeholder="Y-Max" name="ymax" [(ngModel)]="gr.layout.yaxis.range[1]" />
                </clr-input-container>
                <clr-input-container>
                  <label>{{ 'Y-Min' | mrTranslate }}</label>
                  <input clrInput placeholder="Y-Min" name="ymin" [(ngModel)]="gr.layout.yaxis.range[0]" />
                </clr-input-container>
                <button class="btn btn-primary btn-sm" style="margin-top: 1.2rem" (click)="applyYaxis(gr.el)">
                  {{ 'übernehmen' | mrTranslate }}
                </button>
              </form>
            </clr-signpost-content>
          </clr-signpost>
          <!-- @if (!gr.fullsize || gr.fullsize == false) {
          <a href="javascript://" class="nav-link nav-icon">
            <cds-icon
              shape="resize"
              solid="true"
              (click)="resize(gr)"
              style="margin-top: -10px; margin-left: 5px" />
          </a>
        }
        @if (gr.fullsize || gr.fullsize == true) {
          <a href="javascript://" class="nav-link nav-icon">
            <cds-icon
              shape="shrink"
              solid="true"
              (click)="shrink(gr)"
              style="margin-top: -10px; margin-left: 5px" />
          </a>
        } -->
        </div>
      </div>
    </div>
    @if (gr.show) {
      <div class="card-block">
        <div style="width: 100%">
          <div class="clr-col-12">
            <app-plotly-plot
              [data]="gr.data"
              [layout]="gr.layout"
              (plotEl)="gr.el = $event"
              [resizeSubject]="resize$()"
              [config]="graphconfig()"></app-plotly-plot>
          </div>
        </div>
      </div>
    }
  </div>
}
